import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mantine/core/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/vercel/path0/src/app/_providers/AppProviders.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/style.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/datepicker.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datepicker/dist/react-datepicker.css");
